import { Component, Input, OnInit } from '@angular/core';
import { ModalController, IonicModule } from '@ionic/angular';
import { UserInterface } from 'src/app/core/interfaces/user.interface';
import { SearchService } from 'src/app/core/services/search.service';
import { NgIf, NgFor } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-get-user-email-modal',
  templateUrl: './get-user-email-modal.component.html',
  styleUrls: ['./get-user-email-modal.component.scss'],
  standalone: true,
  imports: [
    IonicModule,
    NgIf,
    NgFor,
    TranslateModule
  ],
})
export class GetUserEmailModalComponent implements OnInit {
  @Input() users?: UserInterface[] = [];
  filteredUsers: UserInterface[] = [];

  constructor(public modalController: ModalController,
    private searchService: SearchService) { }

  ngOnInit() {
    this.filteredUsers = this.users;
  }

  onSearch(event) {
    const keys = ['FirstName', 'LastName', 'Email'];
    this.filteredUsers = this.searchService?.searchFunction(keys, event, this.users)
  }

  returnSelectedUser(user: UserInterface) {
    this.modalController.dismiss(user.Email);
  }

  onBack() {
    this.modalController.dismiss(null);
  }
}
